module.exports = __webpack_public_path__ + "assets/arrow-down-white.150d944.png";